
import { ModuleWithProviders } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AuthComponent } from "./auth.component";
// import { ModuleWithProviders } from "@angular/compiler/src/core";

export const routes: Routes = [
  
];

export const routing: ModuleWithProviders<any> = RouterModule.forChild(routes);
